import Question from './Question'
export default class Questionnaire {
  id = 0
  name = ''
  route = ''
  buttonIcon = ''
  headerIcon = ''
  questions = []

  constructor (rawData = {}) {
    this.id = rawData.id
    this.name = rawData.name
    this.route = rawData.route
    this.buttonIcon = rawData.button_icon
    this.headerIcon = rawData.header_icon
    rawData.questions.forEach(question => {
      this.questions.push(new Question(question))
    })
  }
}
